{
  "Clear search": "Очистити пошук"
}
